import { initializeApp } from "firebase/app";
// import 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

import { firebaseConfig } from 'constants/defaultValues';
import { getFirestore } from "firebase/firestore";

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export { firestore };
export const firebaseAnalytics = getAnalytics(app);
export const firebaseAuth = getAuth(app);
export const auth = getAuth(app);
export { app };